import { createFileRoute } from "@tanstack/react-router";
import AdminCriterionDetailPage from "@/pages/admin/criteria/detail";
import { useCriteriaPermissions } from "@/pages/admin/criteria";

export const Route = createFileRoute("/app/admin/criteria/$criterionId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { criterionId } = Route.useParams();
  const {
    currentUser,
    userCanEditAllCriteria,
    userCanViewAllCriteria,
    userCanEditAllMaterials,
    userCanViewAllMaterials,
    userCanAssociateMaterialsAndCriteria,
  } = useCriteriaPermissions();

  return (
    <AdminCriterionDetailPage
      currentUser={currentUser}
      id={Number(criterionId)}
      userCanEditAllCriteria={userCanEditAllCriteria}
      userCanViewAllCriteria={userCanViewAllCriteria}
      userCanEditAllMaterials={userCanEditAllMaterials}
      userCanViewAllMaterials={userCanViewAllMaterials}
      userCanAssociateMaterialsAndCriteria={userCanAssociateMaterialsAndCriteria}
    />
  );
}
